const RequesterData = ({
  Note,
  Name,
  Phone,
  Email,
  CustomerControlIdentifier,
}) => ({
  note: Note ?? '',
  name: Name ?? '',
  phone: Phone ?? '',
  email: Email ?? '',
  customerControlIdentifier: CustomerControlIdentifier ?? '',
})

export default RequesterData
